<!--
 * @Desc: 
 * @Author: 赵佳明
 * @Date: 2022-06-23 15:34:26
 * @LastEditors: 赵佳明
 * @LastEditTime: 2024-07-31 16:17:38
-->
<template>
  <div class="contact_us">
    <!-- 联系我们 -->
    <!-- nav -->
    <index-nav></index-nav>
     <!-- bottom -->
    <index-bottom></index-bottom>
    <div class="content">
      <!-- banner -->
      <div class="banner">
        <img src="/statics/images/info/lx_banner.png" alt />
      </div>
      <!-- 详情 -->
      <div class="lxCon inner">
        <!-- 地图 -->
        <div class="map_pic">
          <div class="map">
            <img src="/statics/images/info/map.png" alt />
          </div>
          <div class="lian">
            <img src="/statics/images/info/lianxi.jpg" alt />
          </div>
        </div>
        <!-- 地址 -->
        <div class="addinfo">
          <div class="name">
            <span>亿兴隆通风设备（河北）有限公司</span>
          </div>
          <div class="add">
            地址：
            <span>河北省衡水市故城县郑口高速口西一公里路北</span>
          </div>
        </div>
        <!-- 电话 -->
        <div class="telList">
          <!-- 通风事业部 -->
          <!-- <div class="zykt">
            <div class="title">
              <span>通风事业部</span>
            </div>
            <div class="info_box">
              <div class="tel">
                <img src="/statics/images/info/tel.png" alt />
                <span>电话：</span>
              </div>
              <div class="num">
                <span>05346351888</span>
                <span>13053436288</span>
              </div>
            </div>
          </div> -->
          <!-- 电厂事业部 -->
          <div class="dcsy">
            <div class="title">
              <span>通风事业部</span>
            </div>
            <div class="dc_info">
              <div class="info_box">
                <div class="tel">
                  <img src="/statics/images/info/tel.png" alt />
                  <span>电话：</span>
                </div>
                <div class="num">
                  <!-- <span>18732871000</span> -->
                  <span>17831807666</span>
                </div>
              </div>
              <div class="info_box">
                <img src="/statics/images/info/eml.png" alt />
                <span>邮箱：yixinglong@139.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom -->
    <!-- <index-bottom></index-bottom> -->
    <!-- footer -->
    <index-footer></index-footer>
  </div>
</template>

<script>
import indexNav from "./../components/nav";
import indexBottom from "./../components/bottom";
import indexFooter from "./../components/footer";
export default {
  data() {
    return {};
  },
  components: {
    indexNav,
    indexBottom,
    indexFooter
  },
  created() {},
  methods: {},
  mounted: function() {}
};
</script>

<style>
</style>